/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LikeDto } from '../../models/like-dto';

export interface LikeControllerFindByUserId$Params {
}

export function likeControllerFindByUserId(http: HttpClient, rootUrl: string, params?: LikeControllerFindByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LikeDto>>> {
  const rb = new RequestBuilder(rootUrl, likeControllerFindByUserId.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LikeDto>>;
    })
  );
}

likeControllerFindByUserId.PATH = '/api/like/my';
